import ToDosIndex from "@/ToDoList/ToDosIndex.vue";

export default [
  {
    path: "/todos",
    name: "TodosIndex",
    component: ToDosIndex
  }
];
